import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import Area from '../algorithm/Area';
import Geometry from './Geometry';
import Arrays from '../../../../java/util/Arrays';
import CoordinateFilter from './CoordinateFilter';
import hasInterface from '../../../../hasInterface';
import IllegalArgumentException from '../../../../java/lang/IllegalArgumentException';
import Orientation from '../algorithm/Orientation';
import CoordinateSequences from './CoordinateSequences';
import GeometryComponentFilter from './GeometryComponentFilter';
import Polygonal from './Polygonal';
import GeometryFilter from './GeometryFilter';
import CoordinateSequenceFilter from './CoordinateSequenceFilter';
var Polygon = /*#__PURE__*/function (_Geometry) {
  _inherits(Polygon, _Geometry);
  function Polygon() {
    var _this;
    _classCallCheck(this, Polygon);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(Polygon).call(this));
    Polygon.constructor_.apply(_assertThisInitialized(_assertThisInitialized(_this)), arguments);
    return _this;
  }
  _createClass(Polygon, [{
    key: "computeEnvelopeInternal",
    value: function computeEnvelopeInternal() {
      return this._shell.getEnvelopeInternal();
    }
  }, {
    key: "getCoordinates",
    value: function getCoordinates() {
      if (this.isEmpty()) return [];
      var coordinates = new Array(this.getNumPoints()).fill(null);
      var k = -1;
      var shellCoordinates = this._shell.getCoordinates();
      for (var x = 0; x < shellCoordinates.length; x++) {
        k++;
        coordinates[k] = shellCoordinates[x];
      }
      for (var i = 0; i < this._holes.length; i++) {
        var childCoordinates = this._holes[i].getCoordinates();
        for (var j = 0; j < childCoordinates.length; j++) {
          k++;
          coordinates[k] = childCoordinates[j];
        }
      }
      return coordinates;
    }
  }, {
    key: "getArea",
    value: function getArea() {
      var area = 0.0;
      area += Area.ofRing(this._shell.getCoordinateSequence());
      for (var i = 0; i < this._holes.length; i++) area -= Area.ofRing(this._holes[i].getCoordinateSequence());
      return area;
    }
  }, {
    key: "copyInternal",
    value: function copyInternal() {
      var shellCopy = this._shell.copy();
      var holeCopies = new Array(this._holes.length).fill(null);
      for (var i = 0; i < this._holes.length; i++) holeCopies[i] = this._holes[i].copy();
      return new Polygon(shellCopy, holeCopies, this._factory);
    }
  }, {
    key: "isRectangle",
    value: function isRectangle() {
      if (this.getNumInteriorRing() !== 0) return false;
      if (this._shell === null) return false;
      if (this._shell.getNumPoints() !== 5) return false;
      var seq = this._shell.getCoordinateSequence();
      var env = this.getEnvelopeInternal();
      for (var i = 0; i < 5; i++) {
        var x = seq.getX(i);
        if (!(x === env.getMinX() || x === env.getMaxX())) return false;
        var y = seq.getY(i);
        if (!(y === env.getMinY() || y === env.getMaxY())) return false;
      }
      var prevX = seq.getX(0);
      var prevY = seq.getY(0);
      for (var _i = 1; _i <= 4; _i++) {
        var _x = seq.getX(_i);
        var _y = seq.getY(_i);
        var xChanged = _x !== prevX;
        var yChanged = _y !== prevY;
        if (xChanged === yChanged) return false;
        prevX = _x;
        prevY = _y;
      }
      return true;
    }
  }, {
    key: "equalsExact",
    value: function equalsExact() {
      if (arguments.length === 2 && typeof arguments[1] === 'number' && arguments[0] instanceof Geometry) {
        var other = arguments[0],
          tolerance = arguments[1];
        if (!this.isEquivalentClass(other)) return false;
        var otherPolygon = other;
        var thisShell = this._shell;
        var otherPolygonShell = otherPolygon._shell;
        if (!thisShell.equalsExact(otherPolygonShell, tolerance)) return false;
        if (this._holes.length !== otherPolygon._holes.length) return false;
        for (var i = 0; i < this._holes.length; i++) if (!this._holes[i].equalsExact(otherPolygon._holes[i], tolerance)) return false;
        return true;
      } else {
        return _get(_getPrototypeOf(Polygon.prototype), "equalsExact", this).apply(this, arguments);
      }
    }
  }, {
    key: "normalize",
    value: function normalize() {
      if (arguments.length === 0) {
        this._shell = this.normalized(this._shell, true);
        for (var i = 0; i < this._holes.length; i++) this._holes[i] = this.normalized(this._holes[i], false);
        Arrays.sort(this._holes);
      } else if (arguments.length === 2) {
        var ring = arguments[0],
          clockwise = arguments[1];
        if (ring.isEmpty()) return null;
        var seq = ring.getCoordinateSequence();
        var minCoordinateIndex = CoordinateSequences.minCoordinateIndex(seq, 0, seq.size() - 2);
        CoordinateSequences.scroll(seq, minCoordinateIndex, true);
        if (Orientation.isCCW(seq) === clockwise) CoordinateSequences.reverse(seq);
      }
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      return this._shell.getCoordinate();
    }
  }, {
    key: "getNumInteriorRing",
    value: function getNumInteriorRing() {
      return this._holes.length;
    }
  }, {
    key: "getBoundaryDimension",
    value: function getBoundaryDimension() {
      return 1;
    }
  }, {
    key: "reverseInternal",
    value: function reverseInternal() {
      var shell = this.getExteriorRing().reverse();
      var holes = new Array(this.getNumInteriorRing()).fill(null);
      for (var i = 0; i < holes.length; i++) holes[i] = this.getInteriorRingN(i).reverse();
      return this.getFactory().createPolygon(shell, holes);
    }
  }, {
    key: "getTypeCode",
    value: function getTypeCode() {
      return Geometry.TYPECODE_POLYGON;
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      return 2;
    }
  }, {
    key: "getLength",
    value: function getLength() {
      var len = 0.0;
      len += this._shell.getLength();
      for (var i = 0; i < this._holes.length; i++) len += this._holes[i].getLength();
      return len;
    }
  }, {
    key: "getNumPoints",
    value: function getNumPoints() {
      var numPoints = this._shell.getNumPoints();
      for (var i = 0; i < this._holes.length; i++) numPoints += this._holes[i].getNumPoints();
      return numPoints;
    }
  }, {
    key: "convexHull",
    value: function convexHull() {
      return this.getExteriorRing().convexHull();
    }
  }, {
    key: "normalized",
    value: function normalized(ring, clockwise) {
      var res = ring.copy();
      this.normalize(res, clockwise);
      return res;
    }
  }, {
    key: "compareToSameClass",
    value: function compareToSameClass() {
      if (arguments.length === 1) {
        var o = arguments[0];
        var thisShell = this._shell;
        var otherShell = o._shell;
        return thisShell.compareToSameClass(otherShell);
      } else if (arguments.length === 2) {
        var _o = arguments[0],
          comp = arguments[1];
        var poly = _o;
        var _thisShell = this._shell;
        var _otherShell = poly._shell;
        var shellComp = _thisShell.compareToSameClass(_otherShell, comp);
        if (shellComp !== 0) return shellComp;
        var nHole1 = this.getNumInteriorRing();
        var nHole2 = poly.getNumInteriorRing();
        var i = 0;
        while (i < nHole1 && i < nHole2) {
          var thisHole = this.getInteriorRingN(i);
          var otherHole = poly.getInteriorRingN(i);
          var holeComp = thisHole.compareToSameClass(otherHole, comp);
          if (holeComp !== 0) return holeComp;
          i++;
        }
        if (i < nHole1) return 1;
        if (i < nHole2) return -1;
        return 0;
      }
    }
  }, {
    key: "apply",
    value: function apply() {
      if (hasInterface(arguments[0], CoordinateFilter)) {
        var filter = arguments[0];
        this._shell.apply(filter);
        for (var i = 0; i < this._holes.length; i++) this._holes[i].apply(filter);
      } else if (hasInterface(arguments[0], CoordinateSequenceFilter)) {
        var _filter = arguments[0];
        this._shell.apply(_filter);
        if (!_filter.isDone()) for (var _i2 = 0; _i2 < this._holes.length; _i2++) {
          this._holes[_i2].apply(_filter);
          if (_filter.isDone()) break;
        }
        if (_filter.isGeometryChanged()) this.geometryChanged();
      } else if (hasInterface(arguments[0], GeometryFilter)) {
        var _filter2 = arguments[0];
        _filter2.filter(this);
      } else if (hasInterface(arguments[0], GeometryComponentFilter)) {
        var _filter3 = arguments[0];
        _filter3.filter(this);
        this._shell.apply(_filter3);
        for (var _i3 = 0; _i3 < this._holes.length; _i3++) this._holes[_i3].apply(_filter3);
      }
    }
  }, {
    key: "getBoundary",
    value: function getBoundary() {
      if (this.isEmpty()) return this.getFactory().createMultiLineString();
      var rings = new Array(this._holes.length + 1).fill(null);
      rings[0] = this._shell;
      for (var i = 0; i < this._holes.length; i++) rings[i + 1] = this._holes[i];
      if (rings.length <= 1) return this.getFactory().createLinearRing(rings[0].getCoordinateSequence());
      return this.getFactory().createMultiLineString(rings);
    }
  }, {
    key: "getGeometryType",
    value: function getGeometryType() {
      return Geometry.TYPENAME_POLYGON;
    }
  }, {
    key: "getExteriorRing",
    value: function getExteriorRing() {
      return this._shell;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return this._shell.isEmpty();
    }
  }, {
    key: "getInteriorRingN",
    value: function getInteriorRingN(n) {
      return this._holes[n];
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [Polygonal];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._shell = null;
      this._holes = null;
      var shell = arguments[0],
        holes = arguments[1],
        factory = arguments[2];
      Geometry.constructor_.call(this, factory);
      if (shell === null) shell = this.getFactory().createLinearRing();
      if (holes === null) holes = [];
      if (Geometry.hasNullElements(holes)) throw new IllegalArgumentException('holes must not contain null elements');
      if (shell.isEmpty() && Geometry.hasNonEmptyElements(holes)) throw new IllegalArgumentException('shell is empty but holes are not');
      this._shell = shell;
      this._holes = holes;
    }
  }]);
  return Polygon;
}(Geometry);
export { Polygon as default };